export const en = {
    'select-empty': 'Empty fields'
};
